var _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPinB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 48,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C7.03 2 3 6.03 3 11c0 5.25 8 11 8.5 11.5.5-.5 8.5-6.25 8.5-11.5 0-4.97-4.03-9-9-9z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 8,
    y: 14,
    fontSize: 10,
    fontFamily: "Arial",
    fontWeight: "bold",
    fill: "white"
  }, "B")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinB);
export default __webpack_public_path__ + "static/media/mapPinB.5fdb3dba390b73dc63d8225389a188c3.svg";
export { ForwardRef as ReactComponent };